var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-center"},[_c('Module',{attrs:{"fluid":_vm.isMobile},on:{"login":_vm.handlerLogin}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }